import api from '../utils/api';

export const login = async (phone, password) => {
  const response = await api.post('/auth/login', { phone, password });
  return response.data;
};

export const register = async (phone, password) => {
  const response = await api.post('/auth/register', { phone, password });
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get('/users/me');
  return response.data;
};

export const updateProfile = async (firstName, lastName) => {
  const response = await api.put('/users/me', { firstName, lastName });
  return response.data;
};

export const getUsers = async () => {
  const response = await api.get('/users');
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
};

export const setUserActive = async (userId, isActive) => {
  const response = await api.patch(`/users/${userId}/active`, { isActive });
  return response.data;
};

export const updateUserByAdmin = async (userId, userData) => {
  const response = await api.put(`/users/${userId}`, userData);
  return response.data;
};

export const updateMySettings = async (settings) => {
  const response = await api.put('/users/me/settings', settings);
  return response.data;
};

export const changePassword = async (currentPassword, newPassword) => {
  const response = await api.put('/users/change-password', {
    currentPassword,
    newPassword,
  });
  return response.data;
};
